if (!customElements.get('wls-newsletter-form')) {
    class WLSNewsletterForm extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          active: 'active',
          buttonSubmit: 'js-newsletter-submit button[type="submit"]',
          feedbackMessage: 'js-feedback-message',
          emailInput: 'input[name="contact[email]"]',
          sectionId: `${this.getAttribute('data-newsletter-form')}`,
          loading: 'loading',
        };
  
        this.selectors = {
          submitButton: this.querySelector(`.${this.classes.buttonSubmit}`),
          feedbackMessage: this.querySelector(`.${this.classes.feedbackMessage}`),
          form: this.querySelector('form'),
          emailInput: this.querySelector(`${this.classes.emailInput}`),
        };
  
        this.apiUrl = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
        this.listGroup = window.theme?.klaviyoId;
  
        this.feedbackMessages = {
          successMessage: 'Thank you for subscribing!',
          validationEmailMessage: 'Please enter a valid email address.',
          alreadySubscribedMessage: 'You have already subscribed.',
          unexpectedErrorMessage: 'An error occurred. Please try again later.',
        };
      }
  
      connectedCallback() {
        this.loadSettings();
        this.bindEvents();
      }
  
      bindEvents() {
        if (this.listGroup) {
          this.selectors.submitButton.addEventListener('click', this.handleSubmit.bind(this));
        } else {
          this.selectors.submitButton.setAttribute('disabled', 'true');
        }
      }
  
      loadSettings() {
        const settingsElement = document.getElementById(`NewsletterFeedbackMessages-${this.classes.sectionId}`);
  
        if (settingsElement) {
          const incomingMessages = JSON.parse(settingsElement.textContent);
  
          Object.keys(incomingMessages).forEach((key) => {
            if (incomingMessages[key]) {
              this.feedbackMessages[key] = incomingMessages[key];
            }
          });
        }
      }
  
      handleSubmit(e) {
        e.preventDefault();
        const isEmail = this.isEmail(this.selectors.emailInput.value);
        this.selectors.submitButton.classList.add(this.classes.loading);
  
        if (isEmail) {
          this.subscribeEmail(this.selectors.emailInput.value, this.selectors.feedbackMessage);
        } else {
          this.displayMessage(this.selectors.feedbackMessage, `${this.feedbackMessages.validationEmailMessage}`, 'error');
          this.selectors.submitButton.classList.remove(this.classes.loading);
        }
      }
  
      async subscribeEmail(email, messageSelector) {
        try {
          const response = await fetch(this.apiUrl, {
            headers: {
              accept: 'application/json, text/plain, */*',
              'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: new URLSearchParams({ g: this.listGroup, email }),
            method: 'POST',
          });
  
          const data = await response.json();
  
          if (data.data.is_subscribed) {
            this.displayMessage(messageSelector, `${this.feedbackMessages.alreadySubscribedMessage}`, 'error');
          } else if (data.success) {
            this.displayMessage(messageSelector, `${this.feedbackMessages.successMessage}`, 'success');
          }
        } catch (error) {
          this.displayMessage(messageSelector, `${this.feedbackMessages.unexpectedErrorMessage}`, 'error');
        } finally {
          this.selectors.submitButton.classList.remove(this.classes.loading);
        }
      }
  
      displayMessage(selector, message, type) {
        selector.innerHTML = message;
        selector.classList.toggle('success', type === 'success');
        selector.classList.toggle('error', type === 'error');
      }
  
      isEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }
    }
  
    window.customElements.define('wls-newsletter-form', WLSNewsletterForm);
  }
  